const conversationEnumerators = {
  type: [
    'individual',
    'group',
  ],
}

export default conversationEnumerators
